// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"f87eaf0a","486":"60f916c0","689":"3225c605","838":"b4e51ccb"}[chunkId] + ".css";
};